export default "https://cdn-web.disco.co/self-paced-course-9970592f2aff316548051c36569be968.png";